import { computed, watch, type ComputedRef } from 'vue';

interface EditModalCommonContext {
  editModalTitle: ComputedRef<string>;
}

// Admin系の編集モーダルに共通する配線をまとめたcomposable。
// - モーダルタイトル（編集/新規作成）の算出
// - 親から渡された編集対象propをローカルstateへ複製するwatch
//   （propを直接編集すると保存前の変更が親側データへ漏れるため、編集用コピーを作る。
//     親はモーダルをv-ifで開閉するためimmediateで初期化も兼ねる）
export function useEditModalCommon<T extends object>(
  props: { isEditMode: boolean },
  source: () => T,
  applyCopy: (copied: T) => void,
): EditModalCommonContext {
  const editModalTitle = computed<string>(() => {
    return props.isEditMode ? '編集' : '新規作成';
  });

  watch(source, newVal => applyCopy({ ...newVal }), { immediate: true });

  return { editModalTitle };
}
